/**
 * @example
 * // ALPHA VIDEO
 {
    id: 'alpha_video',
    loop: true,
    tracks: [
      {
        type: 'video',
        src: [
          {
            url: require('assets/media/alpha_video/alpha_spritesheet_1280x1440.mp4'),
            bitrate: 500,
          },
        ],
        attr: {
          muted: true,
        },
        canvasReady: true,
        preload: 'buffer', // 'no', 'buffer', 'full'
      },
    ],
  }
 */

export default [

]
